import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconOpenNewTab(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a1 1 0 1 0-2 0v5H5V5h5a1 1 0 1 0 0-2H5Zm10 0a1 1 0 1 0 0 2h2.586l-6.293 6.293a1 1 0 0 0 1.414 1.414L19 6.414V9a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1h-5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
